import { render, staticRenderFns } from "./CommentComponent.vue?vue&type=template&id=4e06f7c0&scoped=true&"
import script from "./CommentComponent.vue?vue&type=script&lang=js&"
export * from "./CommentComponent.vue?vue&type=script&lang=js&"
import style0 from "./CommentComponent.vue?vue&type=style&index=0&id=4e06f7c0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e06f7c0",
  null
  
)

export default component.exports